import { AuditLogsResponse, AuditLogFilters } from '../types';
import apiClient from './apiClient';

export interface AuditLogsQueryParams {
  page?: number;
  per_page?: number;
  entity_type?: string;
  action?: string;
  user_id?: number;
  start_date?: string;
  end_date?: string;
  search?: string;
}

export const auditLogsApi = {
  getLogs: async (params?: AuditLogsQueryParams): Promise<AuditLogsResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', String(params.page));
    if (params?.per_page) queryParams.append('per_page', String(params.per_page));
    if (params?.entity_type) queryParams.append('entity_type', params.entity_type);
    if (params?.action) queryParams.append('action', params.action);
    if (params?.user_id) queryParams.append('user_id', String(params.user_id));
    if (params?.start_date) queryParams.append('start_date', params.start_date);
    if (params?.end_date) queryParams.append('end_date', params.end_date);
    if (params?.search) queryParams.append('search', params.search);

    const query = queryParams.toString();
    return apiClient.get<AuditLogsResponse>(`/audit-logs${query ? `?${query}` : ''}`);
  },

  getFilters: async (): Promise<AuditLogFilters> => {
    return apiClient.get<AuditLogFilters>('/audit-logs/filters');
  },
};
